import { isArray } from "lodash";
import { useState } from "react";

const VestingSchedule = ({ data }) => {
    console.log("VestingSchedule", data);
    if (data) {
        const [currentPage, setCurrentPage] = useState(0);
        let totalPages = data.paging.total / data.paging.itemsPerPage;

        if (totalPages != (totalPages | 0)) {
            totalPages = (totalPages | 0) + 1;
        }

        console.log({ totalPages, currentPage });
        const renderTableHeaders = () => {
            return (
                <div className="flex flex-row justify-between items-center w-full">
                    <div className="w-[50%] md:w-[45%]">
                        <span className="uppercase font-secondary">
                            {data.schedule.headers.date}
                        </span>
                    </div>
                    <div className="w-[5%] md:w-[25%] shrink-0 text-center">
                        <span className="uppercase font-secondary">
                            {data.schedule.headers.percent}
                        </span>
                    </div>
                    <div className="w-[40%] md:w-[30%] shrink-0 flex justify-end">
                        <span className="uppercase font-secondary">
                            {data.schedule.headers.amount}
                        </span>
                    </div>
                </div>
            );
        };
        const renderTableRows = () => {
            let count = data.paging.itemsPerPage;
            let start = currentPage * count;
            let end = (currentPage + 1) * count;
            if (end > data.schedule.rows.length) end = data.schedule.rows.length - 1;
            var dataRows = data.schedule.rows.slice(start, end);
            var tableRows = [];
            return dataRows.map((e, index) => (
                <div
                    key={index.toString()}
                    className="flex flex-row justify-between items-center font-roboto rounded-lg px-2 md:px-4 py-1 bg-white/[.18] w-full"
                >
                    <div className="text-left w-[50%] md:w-[55%] lg:w-[50%] border-solid border-[#979797] border-r-[1px] overflow-hidden truncate">
                        <span>{e.datetime}</span>
                    </div>
                    <div className="text-center w-[15%] md:w-[15%] lg:w-[15%] shrink-0 border-solid border-[#979797] border-r-[1px]">
                        <span className="">{e.percent}</span>
                    </div>
                    <div className="flex flex-row justify-end items-center text-center w-[35%] md:w-[35%] lg:w-[35%] shrink-0 space-x-1">
                        <div className="w-[80%] shrink-0">
                            <span className="text-center">{e.amount.toLocaleString("en")}</span>
                        </div>
                        <div className={e.claimed ? "visible" : "invisible"}>
                            <svg
                                className={"w-[13px] md:w-[17px] h-[13px] md:h-[17px]"}
                                viewBox="0 0 46 46"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g fill="none" fillRule="evenodd">
                                    <circle fill="#A7DC68" cx="23" cy="23" r="23" />
                                    <path
                                        stroke="#FFF"
                                        strokeWidth="5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M13 21.695 20.447 30 33 16"
                                    />
                                </g>
                            </svg>
                        </div>
                    </div>
                </div>
            ));
        };

        const handleFirstPage = () => {
            setCurrentPage(0);
        };
        const handleLastPage = () => {
            setCurrentPage(totalPages - 1);
        };
        const handleChangePage = (i) => {
            setCurrentPage(i);
        };
        const renderPages = () => {
            var pages = [];
            for (var i = 0; i < totalPages; i++) {
                pages.push(
                    <button key={i.toString()} onClick={() => handleChangePage(i)}>
                        <div
                            className={
                                currentPage == i ? "rounded-[4px] px-2 bg-darkGray" : "px-1"
                            }
                        >
                            <span className={"text-sm underline-offset-4"}>{i + 1}</span>
                        </div>
                    </button>
                );
            }
            return pages;
        };
        const renderPaging = () => {
            return (
                <div className="flex flex-row text-primary font-roboto text-xs space-x-3">
                    <button onClick={() => handleFirstPage()}>
                        <div className="">
                            <svg
                                width="9"
                                height="16"
                                viewBox="0 0 10 17"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M8.24 1 1 8.24l7.24 7.239"
                                    stroke="#FFF"
                                    strokeWidth="2"
                                    fill="none"
                                    fillRule="evenodd"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </div>
                    </button>
                    <div className="flex flex-row space-x-3">{renderPages()}</div>
                    <button onClick={() => handleLastPage()}>
                        <div className="rotate-180">
                            <svg
                                width="9"
                                height="16"
                                viewBox="0 0 10 17"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M8.24 1 1 8.24l7.24 7.239"
                                    stroke="#FFF"
                                    strokeWidth="2"
                                    fill="none"
                                    fillRule="evenodd"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </div>
                    </button>
                </div>
            );
        };
        return (
            <div className="flex flex-col bg-vestingSchedule rounded-xl bg-blur-xl text-primary space-y-5 md:space-y-7 px-4 md:px-7 py-5 md:py-7 w-full">
                <div className="">
                    <span className="uppercase font-primary text-sm md:text-lg">
                        {data.title}
                    </span>
                </div>
                <div className="flex flex-col items-center space-y-3 text-xs md:text-sm">
                    {renderTableHeaders()}
                    {renderTableRows()}
                </div>
                <div className="flex justify-center w-full">{renderPaging()}</div>
            </div>
        );
    }
    return null;
};

export default VestingSchedule;
